import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        "teen-green": "border-teen-green/30 bg-teen-green-bright text-teen-green",
        "teen-blue": "border-teen-blue/30 bg-teen-blue-bright text-teen-blue",
        "teen-purple": "border-teen-purple/30 bg-teen-purple-bright text-teen-purple",
        "teen-gold": "border-teen-gold/30 bg-teen-gold-bright text-teen-gold",
        "teen-cyan": "border-teen-cyan/30 bg-teen-cyan-bright text-teen-cyan",
        "teen-orange": "border-teen-orange/30 bg-teen-orange-bright text-teen-orange",
        "teen-pink": "border-teen-pink/30 bg-teen-pink-bright text-teen-pink",
        "teen-red": "border-teen-red/30 bg-teen-red-bright text-teen-red",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
